/**
 * Owner: Masa Bayu
 * File: catalog-offers.ts
 * Date:Time: 2026-10-23 01:25
 * Description: §466 S3 — tawaran komersial dijana daripada katalog qxp-hub dan
 *   harga SSOT descriptor. Tiada carta harga tempatan: buku yang tidak mempunyai
 *   harga di hub tidak mempunyai tawaran.
 */

import { offerFromCatalogEntry, type QxreadCommerceOffer } from '@qx/qxread-core';
import { getCatalogEntry, listCatalog } from '../publication/catalog-port';
import { getHubPrice } from '../publication/hub-pricing';

/** Satu tawaran untuk satu terbitan (katalog + harga hub); null jika tiada harga SSOT. */
export function findCatalogOffer(publicationId: string): QxreadCommerceOffer | null {
  const entry = getCatalogEntry(publicationId);
  if (entry === null) return null;
  const price = getHubPrice(entry.publicationId);
  if (price === null) return null;
  return Object.freeze({
    ...offerFromCatalogEntry(entry, price.priceMinorUnits),
    currency: price.currency,
  });
}

/** Semua tawaran yang boleh dijual (hanya terbitan berharga hub). */
export function listCatalogOffers(): readonly QxreadCommerceOffer[] {
  const offers: QxreadCommerceOffer[] = [];
  for (const entry of listCatalog()) {
    const offer = findCatalogOffer(entry.publicationId);
    if (offer !== null) offers.push(offer);
  }
  return Object.freeze(offers);
}

/**
 * §466 S2 — gerbang paparan CTA Beli: `addDemoOfferToCart()` gagal-keras tanpa
 * tawaran, jadi UI hanya menawarkan butang yang memang boleh dilaksanakan.
 */
export function hasCatalogOffer(publicationId: string): boolean {
  return findCatalogOffer(publicationId) !== null;
}
